import { mergeConstants } from '@/store/modules/constant/defaults';

const mutations = {
  setConstants(state, constants) {
    state.constants = mergeConstants(constants);
  },
  setInitializeState(state, initializeState = {}) {
    state.initializeState = {
      ...(state.initializeState ?? {}),
      ...initializeState
    };
  }
};

export default mutations;
